import styled from "styled-components"

import { when } from "utils"

export const Wrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 0;
  height: 2px;
  display: block;
  background: #222;

  ${when("hide")`
    visibility: hidden;
  `}
`
